export default __webpack_public_path__ + "static/media/AINU-Logo.b5c2291c.png";